import { useMemo } from "react";

import { useLocalizedHref } from "@libraries/web-framework";
import { useIntl } from "react-intl";

import FeatureGates from "@atlassian/feature-gate-js-client";

import BannerAlert from "@/components/wpl/banner-alert/src";
import { cssReset } from "@/libraries/wpl/foundations/src";
import GlobalFooter from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";

import BlogsSection from "./sections/blogs";
import CTASection from "./sections/cta";
import DevOpsSection from "./sections/dev-ops";
import HeroSection from "./sections/hero";
import IntegrationSection from "./sections/integrations";
import ScalingSection from "./sections/scaling";
import JiraSoftwareNav from "./sections/software-jira-navbar";
import TabSectionControl from "./sections/tabs";
import TabSectionTreatment from "./sections/tabs-variant-ATLAS-45343";
import WorkflowSection from "./sections/workflow";

export const JiraSoftwarePageTemplate = () => {
    const intl = useIntl();

    const bannerMessages = {
        identifier: "jira-software.banner-alert.atlassian-intelligence",
        text: intl.formatMessage({
            id: "jira-software.banner-alert.text",
            defaultMessage:
                "Get early access to Atlassian Intelligence, your new virtual teammate that deeply understands how teams collaborate to accelerate work."
        }),
        linkText: intl.formatMessage({
            id: "jira-software.banner-alert.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: useLocalizedHref("/software/artificial-intelligence")
    };

    const isJswInteractiveBoardExperimentEnabled = useMemo(() => {
        // Temporary locale check in code as locale is not yet available in Statsig
        // Pre-approved by Sam Gibson
        if (intl.locale === "en") {
            return FeatureGates.getExperimentValue(
                "web-platform-jsw-pt-interactive-board",
                "showInteractiveBoard",
                false
            );
        }
        return false;
    }, [intl.locale]);

    const TabsSection = isJswInteractiveBoardExperimentEnabled
        ? TabSectionTreatment
        : TabSectionControl;
    return (
        <div css={cssReset}>
            <div>
                <GlobalNavigation showTryNow={false} color={"#f4f5f7"} />
            </div>
            <JiraSoftwareNav />
            <BannerAlert
                identifier={bannerMessages.identifier}
                text={bannerMessages.text}
                linkUrl={bannerMessages.linkUrl}
                linkText={bannerMessages.linkText}
            />
            <HeroSection />
            <TabsSection />
            <WorkflowSection />
            <IntegrationSection />
            <DevOpsSection />
            <BlogsSection />
            <ScalingSection />
            <CTASection />
            <GlobalFooter />
        </div>
    );
};
